<template>
    <div>
        <label class="custom-file-upload align-items-center">
            <input :key="uploadRandomKey"
                :id="inputId"
                v-on:change="uploadFile"
                ref="input"
                type="file"
                :accept="acceptedTypes"
                class="form-control"
                :disabled="!_.isEmpty(uploading)"
                :required="!!field.required"
                :multiple="!!field.multiple" />

            <div v-if="!_.isEmpty(currentFiles)"
                :class="['input-text form-control mr-2']">
                <span v-for="file, i in currentFiles"
                    :key="i"
                    :class="[_.has(error, i) ? 'error' : '', 'input-text-file mr-2']">
                    {{ truncFilename(file.name) }}
                    <loader-icon v-if="_.has(uploading, i)" size="0.75x" class="ml-2" />
                    <button v-else
                        v-on:click="removeFile(i)"
                        type="button"
                        class="ml-2 btn btn-transparent btn-rounded btn-sm p-0">
                        <alert-circle-icon v-if="_.has(error, i)" size="0.75x" class="m-0" />
                        <x-icon v-else size="0.75x" class="m-0" />
                    </button>
                </span>
            </div>
            <span v-else :class="[!_.isEmpty(uploading) ? 'disabled': '', !_.isEmpty(error) || invalid ? 'error' : '', 'input-text form-control mr-2']" style="padding-bottom: 6px;">
                Choose file<template v-if="field.multiple">s</template> to upload
            </span>
            <span :class="[!_.isEmpty(uploading) ? 'disabled': '', 'input-button btn btn-primary']">
                <template v-if="!_.isEmpty(uploading)">Uploading...</template>
                <template v-else>
                    Choose File<template v-if="field.multiple">s</template>
                </template>
            </span>
        </label>
        <small class="d-block">
            Accepted File Types : {{ displayTypes }}
            <template v-if="_.get(field, 'multiple', false)"><br>Maximum files: {{ fileLimit }}</template>
        </small>

        <div v-if="!_.isEmpty(error)" class="invalid-feedback d-block">
            <span v-for="err, ei in error" :key="ei" class="d-block">{{ err }}</span>
        </div>

        <p v-if="!_.isNull(field.help)" class="small text-primary my-2">{{ field.help }}</p>
    </div>
</template>
<script>
import UtilsMixin from '../UtilsMixin';
import RadioListComponent from '../form/RadioListComponent';

import { XIcon, LoaderIcon, AlertCircleIcon } from 'vue-feather-icons';

export default {
    data() {
        return {
            uploadRandomKey: 'upload_file_' + Math.floor(Math.random() * 1000000),
            localValue: [],
            uploading: {},
            error: {},
        }
    },

    props: ['value', 'application', 'config', 'invalid'],

    components: {
        RadioListComponent,
        XIcon,
        LoaderIcon,
        AlertCircleIcon,
    },

    mixins: [UtilsMixin],

    created() {
        let currentValue = _.get(this, 'value', []);
        if (!currentValue) {
            this.localValue = [];
        } else if (!_.isArray(currentValue)) {
            this.localValue = [currentValue];
        } else {
            this.localValue = currentValue;
        }
    },

    mounted() {

    },

    watch: {
        localValue: {
            handler(newVal) {
                this.$nextTick(() => {
                    let emitVal = newVal.filter((lv) => {
                        if (_.isUndefined(lv)) {
                            return false;
                        }
                        return lv.ignore == false;
                    });
                    if (this.field.multiple) {
                        this.$emit('input', emitVal);
                        return;
                    }
                    this.$emit('input', _.first(emitVal));
                });
            },
            deep: true,
        }
    },

    computed: {

        currentFiles() {
            let currentFiles = {};
            _.get(this, 'localValue', [])
                .map((lv, lvi) => {
                    if (!_.isUndefined(lv)) {
                        currentFiles[lvi] = lv;
                    }
                    return lv;
                });
            return currentFiles;
        },

        fileLimit() {
            if (!this.field.multiple) {
                return 1;
            }
            return _.get(this.field, 'file_limit', 3);
        },

        field() {
            return _.get(this.config, 'field', {});
        },

        selectedTypes() {
            return _.get(this.config, 'fileTypes', []);
        },

        displayTypes() {
            return _.join(_.map(this.selectedTypes, st => '.' + st), ', ');
        },

        fileTypes() {

            let types = [];
            this.selectedTypes.forEach((type) => {
                switch (type) {
                    case 'pdf':
                        types.push('application/pdf');
                        break;
                    case 'jpg':
                        types.push('image/jpeg');
                        break;
                    case 'png':
                        types.push('image/png');
                        break;
                    case 'doc':
                        types.push('application/msword');
                        break;
                    case 'docx':
                        types.push('application/vnd.openxmlformats-officedocument.wordprocessingml.document');
                        break;
                    case 'xls':
                        types.push('application/vnd.ms-excel');
                        break;
                    case 'xlsx':
                        types.push('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                        break;
                    case 'txt':
                        types.push('text/plain');
                        break;
                }
            });
            return types;
        },

        acceptedTypes() {
           return this.fileTypes.join(", ");
        },

        input() {
            return this.$refs['input'];
        },

        inputId() {
            return _.get(this.config, 'inputId');
        },
    },

    methods: {
        uploadFile(e) {
            let fileCount = 0;
            Array.prototype.forEach.call(e.target.files, (file, ind) => {
                fileCount++;

                // fill the spans
                this.$set(this.localValue, ind, file);
                this.uploading[ind] = true;

                // error handling
                if (fileCount > this.fileLimit) {
                    this.error[ind] = file.name + ': File exceeds limit (' + this.fileLimit + ')';
                    this.$set(this.localValue[ind], 'ignore', true);
                    delete this.uploading[ind];
                    this.$forceUpdate();
                    return;
                }
                if (!file) {
                    this.error[ind] = file.name + ': File not selected';
                    this.$set(this.localValue[ind], 'ignore', true);
                    delete this.uploading[ind];
                    this.$forceUpdate();
                    return;
                }

                // upload asset
                this.api.uploadData('/assets', {}, {
                    storage: 'secure_assets',
                    file,
                }).then(res => {
                    this.$set(this.localValue, ind, {
                        ...res,
                        ignore: false,
                    });
                    delete this.error[ind];
                }).catch((err) => {
                    console.log(err);
                    this.error[ind] = file.name + ': Unable to upload file';
                    this.$set(this.localValue[ind], 'ignore', true);
                }).finally(() => {
                    delete this.uploading[ind];
                    this.$forceUpdate();
                });
            });
        },

        removeFile(index) {
            delete this.uploading[index];
            delete this.error[index];
            this.$set(this.localValue, index, undefined);
            this.$forceUpdate();
        },

        truncFilename(filename) {
            if (filename.length > 15) {
                filename = filename.substring(0, 15) + "...";
            }
           return filename;
        },

    },
}
</script>
